// export const VITSPOT_TIMETABLE_API_URI = 'https://timetable-api.vitspot.com';
export const VITSPOT_TIMETABLE_API_URI = 'https://timetable-api.vitspot.com';
export const VITSPOT_TIMETABLE_TUTORIAL = 'https://vitspot.com/posts/vitspot-timetable/';